<template>
	<div class="container-fluid">
		<div class="card">
      <div class="card-header">
        <h2 class="card-title">Buzón de Ayuda</h2>
      </div>
      <div class="card-body">
        <template v-if="!historial">
          <div class="row">
            <div class="col-sm-6"><h3 >Consultas / Solicitudes realizadas</h3></div>
            <div class="col-sm-4 offset-2">
              <button class="btn btn-block btn-success" @click="ticket=true">Realizar una Consulta / Solicitud</button>
            </div>
          </div>          
        </template>

        <Card/>

      </div>
    </div>

      <Ticket v-if="ticket" @close="cerrar_modal_ticket"/>

	</div>
</template>

<script>
import Ticket from "../components/Buzon/Ticket";
import Card from "../components/Buzon/Card";
export default {

  components:{
    Ticket, Card,
  },
  data(){
    return{
      ticket: false,
      historial:false,
    }
  },
  methods:{
    cerrar_modal_ticket(){
      this.ticket = false;
    }
  }

}
</script>

<style lang="scss" scoped>

	.nav-link {
		cursor: pointer;
	}

</style>